import { HeaderLinksConfig } from '@shared/models/links-config-model';
import { ProductName } from '@core/constants';

export const NavigationLinksConfig: Record<ProductName, HeaderLinksConfig[]> = {
  [ProductName.DMEPOS_MA]: [
    {
      label: 'Resource Routing Rules',
      url: '/rules',
      permissions: ['DMEPOSAuthorizationCaseRule.Read'],
    },
    {
      label: 'Resource Routing Metrics',
      url: '/metrics',
      permissions: ['DMEPOSAuthorizationCaseMetric.Read'],
    },
    {
      label: 'Routing Queue',
      url: '/queue',
      permissions: ['DMEPOSAuthorizationCaseQueue.Read'],
    },
  ],
  [ProductName.DMEPOS_MCD]: [
    {
      label: 'Resource Routing Rules',
      url: '/rules',
      permissions: ['DMEPOSMedicaidRule.Read'],
    },
    {
      label: 'Resource Routing Metrics',
      url: '/metrics',
      permissions: ['DMEPOSMedicaidMetric.Read'],
    },
    {
      label: 'Routing Queue',
      url: '/queue',
      permissions: ['DMEPOSMedicaidQueue.Read'],
    },
  ],
  [ProductName.HH]: [
    {
      label: 'Resource Routing Rules',
      url: '/rules',
      permissions: ['HHServiceLineRule.Read'],
    },
    {
      label: 'Resource Routing Metrics',
      url: '/metrics',
      permissions: ['HHServiceLineMetric.Read'],
    },
    {
      label: 'Routing Queue',
      url: '/queue',
      permissions: ['HHServiceLineQueue.Read'],
    },
  ],
  [ProductName.PAC_MA]: [
    {
      label: 'Resource Routing Rules',
      url: '/rules',
      permissions: ['PACMAServiceLineRule.Read'],
    },
    {
      label: 'Resource Routing Metrics',
      url: '/metrics',
      permissions: ['PACMAServiceLineMetric.Read'],
    },
    {
      label: 'Routing Queue',
      url: '/queue',
      permissions: ['PACMAServiceLineQueue.Read'],
    },
  ],
  [ProductName.PAC_COM]: [
    {
      label: 'Resource Routing Rules',
      url: '/rules',
      permissions: ['PACCOMServiceLineRule.Read'],
    },
    {
      label: 'Resource Routing Metrics',
      url: '/metrics',
      permissions: ['PACCOMServiceLineMetric.Read'],
    },
    {
      label: 'Routing Queue',
      url: '/queue',
      permissions: ['PACCOMServiceLineQueue.Read'],
    },
  ],
};
